import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import "../../../Public/css/fonts.css";

function Dashboard({ allowedRoles }) {
  const { designation, setallStateList, setUserDetails, userDetails } =
    useAuth();
  const [dashboardvalue, SetDashboardvalue] = useState();
  const { allowLoading } = useAuthentication(allowedRoles);
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;

  const location = useLocation();

  useEffect(() => {
    if (designation) {
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: `/dashboard`,
      })
        .then((response) => {
          if (response?.data) {
            SetDashboardvalue(response?.data[0]);
          } else {
            SetDashboardvalue();
          }
        })
        .catch((e) => {
          // setLoading(false);
        });
    }
  }, [designation]);

  //   useEffect(()=>{
  // if(location.state?.reload==1){
  //   axiosFetch({
  //     axiosInstance: axios,
  //     method: 'GET',
  //     url: "/userDetails",

  // })
  //     .then((response) => {
  //
  //       setUserDetails(response.data?.UserDetails)
  //     })
  //   }

  // },[location])
  return (
    <DashboardLayouts>
      <div className="dash-area1 d-flex justify-content-lg-start">
        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">Buildings</p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {dashboardvalue?.buildingList}
            </h2>
          </div>
        </div>

        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">
              {designation !== "Admin" ? "Units" : "Accountant"}
            </p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {designation !== "Admin"
                ? dashboardvalue?.unitList
                : dashboardvalue?.accountantList}
            </h2>
          </div>
        </div>
        {designation !== "Manager" && designation !== "Accountant" && (
          <div className="card dash-unit">
            <div className="card-body">
              <p className="card-text card-title-4 dash-text">Manager</p>
              <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
                {dashboardvalue?.managerList}
              </h2>
            </div>
          </div>
        )}
        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">Worker</p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {dashboardvalue?.workerList}
            </h2>
          </div>
        </div>
        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">
              {designation !== "Admin" ? "Pending Tasks" : "Owner"}
            </p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {designation !== "Admin"
                ? dashboardvalue?.taskList
                : dashboardvalue?.ownerList}
            </h2>
          </div>
        </div>

        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">
              {designation !== "Admin" ? "Pending Request" : "Partner"}
            </p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {designation !== "Admin"
                ? dashboardvalue?.requestList
                : dashboardvalue?.partnerList}
            </h2>
          </div>
        </div>

        <div className="card dash-unit">
          <div className="card-body">
            <p className="card-text card-title-4 dash-text">Tenant</p>
            <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
              {dashboardvalue?.tenantList}
            </h2>
          </div>
        </div>
        {designation !== "Manager" ||
          (designation !== "Accountant" && (
            <div className="card dash-unit me-0">
              <div className="card-body">
                <p className="card-text card-title-4 dash-text">Accountant</p>
                <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
                  {dashboardvalue?.accountList}
                </h2>
              </div>
            </div>
          ))}
      </div>

      <hr className="w-100 line-2" />
      <div className="dash-area2">
        <div className="card border-0 dash-manage">
          <Link
            to={
              designation !== "Admin" ? "/buildinglist" : "/admin/buildinglist"
            }
          >
            <div className="card-body bg-secondary text-center card-box">
              <i className="icon-manage-building"></i>
              <h2 className="card-title text-primary dash-manage-heading">
                Manage Buildings
              </h2>
            </div>
          </Link>
        </div>
        {designation == "Admin" && (
          <div className="card border-0 dash-manage">
            <Link to={"/admin/ownerlist"}>
              <div className="card-body bg-secondary text-center card-box">
                <i className="icon-manage-employee"></i>
                <h2 className="card-title text-primary dash-manage-heading">
                  Manage Owner
                </h2>
              </div>
            </Link>
          </div>
        )}
        {designation !== "Partner" &&
          designation !== "Manager" &&
          designation !== "Accountant" && (
            <>
              <div className="card border-0 dash-manage">
                <Link
                  to={
                    designation !== "Admin"
                      ? "/partnerlist"
                      : "/admin/partnerlist"
                  }
                >
                  <div className="card-body bg-secondary text-center card-box">
                    <i className="icon-manage-employee"></i>
                    <h2 className="card-title text-primary dash-manage-heading">
                      Manage Partner
                    </h2>
                  </div>
                </Link>
              </div>
              <div className="card border-0 dash-manage">
                <Link
                  to={
                    designation !== "Admin"
                      ? "/accountantlist"
                      : "/admin/accountantlist"
                  }
                >
                  <div className="card-body bg-secondary text-center card-box">
                    <i className="icon-manage-request"></i>
                    <h2 className="card-title text-primary dash-manage-heading">
                      Manage Accountant
                    </h2>
                  </div>
                </Link>
              </div>
            </>
          )}

        {designation !== "Manager" && designation !== "Accountant" && (
          <div className="card border-0 dash-manage">
            <Link
              to={
                designation !== "Admin" ? "/managerlist" : "/admin/managerlist"
              }
            >
              <div className="card-body bg-secondary text-center card-box">
                <i className="icon-manage-employee"></i>
                <h2 className="card-title text-primary dash-manage-heading">
                  Manage Manager
                </h2>
              </div>
            </Link>
          </div>
        )}
        <div className="card border-0 dash-manage ">
          <Link
            to={designation !== "Admin" ? "/workerlist" : "/admin/workerlist"}
          >
            <div className="card-body bg-secondary text-center card-box">
              <i className="icon-manage-building"></i>
              <h2 className="card-title text-primary dash-manage-heading">
                Manage Worker
              </h2>
            </div>
          </Link>
        </div>
        {designation !== "Admin" && (
          <div className="card border-0 dash-manage">
            <Link to="/view-request">
              <div className="card-body bg-secondary text-center card-box">
                <i className="icon-manage-tenant"></i>
                <h2 className="card-title text-primary dash-manage-heading">
                  Manage Request
                </h2>
              </div>
            </Link>
          </div>
        )}
        <div className="card border-0 dash-manage ">
          <Link
            to={designation !== "Admin" ? "/tenantlist" : "/admin/tenantlist"}
          >
            <div className="card-body bg-secondary text-center card-box">
              <i className="icon-manage-building"></i>
              <h2 className="card-title text-primary dash-manage-heading">
                Manage Tenant
              </h2>
            </div>
          </Link>
        </div>
        {designation !== "Admin" && (
          <>
            <div className="card border-0 dash-manage">
              <Link to={"/owner/rent/collection-management"}>
                <div className="card-body bg-secondary text-center card-box">
                  <i className="icon-manage-employee"></i>
                  <h2 className="card-title text-primary dash-manage-heading">
                    Collection Management
                  </h2>
                </div>
              </Link>
            </div>
            <div className="card border-0 dash-manage">
              <Link to="/owner/revenue">
                <div className="card-body bg-secondary text-center card-box">
                  <i className="icon-manage-task"></i>
                  <h2 className="card-title text-primary dash-manage-heading">
                    Revenue Management
                  </h2>
                </div>
              </Link>
            </div>
            <div className="card border-0 dash-manage">
              <Link to="/comingpage">
                <div className="card-body bg-secondary text-center card-box">
                  <i className="icon-manage-task"></i>
                  <h2 className="card-title text-primary dash-manage-heading">
                    Expense Management
                  </h2>
                </div>
              </Link>
            </div>
            <div className="card border-0 dash-manage">
              <Link to={"/owner/cash-management"}>
                <div className="card-body bg-secondary text-center card-box">
                  <i className="icon-manage-request"></i>
                  <h2 className="card-title text-primary dash-manage-heading">
                    Cash Management
                  </h2>
                </div>
              </Link>
            </div>

            <div className="card border-0 dash-manage">
              <Link to="/owner/banking-information">
                <div className="card-body bg-secondary text-center card-box">
                  <i className="icon-manage-tenant"></i>
                  <h2 className="card-title text-primary dash-manage-heading">
                    Banking Information
                  </h2>
                </div>
              </Link>
            </div>
          </>
        )}
        <div className="card border-0 dash-manage">
          <Link
            to={
              designation !== "Admin"
                ? "/owner/taxation-information"
                : "/admin/taxation-information"
            }
          >
            <div className="card-body bg-secondary text-center card-box">
              <i className="icon-manage-employee"></i>
              <h2 className="card-title text-primary dash-manage-heading">
                Taxation Information
              </h2>
            </div>
          </Link>
        </div>
      </div>
    </DashboardLayouts>
  );
}
export default Dashboard;
